import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown, FaPlay } from 'react-icons/fa';
import BookingForm from '../BookingForm/BookingForm';
import './Hero.css';

const slides = [
  {
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1920&q=90",
    title: "Experience True Luxury",
    subtitle: "Where Elegance Meets Comfort",
    description: "Discover a world of unparalleled luxury at Grand Luxe Hotel & Spa — where every moment is crafted to perfection.",
  },
  {
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1920&q=90",
    title: "Breathtaking Views",
    subtitle: "Infinity Pool & Sky Bar",
    description: "Immerse yourself in panoramic city views from our stunning rooftop infinity pool and cocktail lounge.",
  },
  {
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=1920&q=90",
    title: "Exquisite Accommodations",
    subtitle: "Presidential & Luxury Suites",
    description: "Our meticulously appointed suites offer the finest furnishings, bespoke services, and unrivaled comfort.",
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const handleSlide = (i) => {
    if (i !== current) {
      setCurrent(i);
    }
  };

  return (
    <section className="hero">
      <div className="hero-slides">
        <AnimatePresence>
          <motion.div
            key={current}
            className="hero-slide"
            style={{ backgroundImage: `url(${slides[current].image})` }}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: 'easeInOut' }}
          />
        </AnimatePresence>
        <div className="hero-overlay" />
      </div>

      <div className="hero-content">
        <div className="container">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              className="hero-text"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <motion.span
                className="hero-badge"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2, duration: 0.6 }}
              >
                ✦ &nbsp;{slides[current].subtitle}&nbsp; ✦
              </motion.span>

              <motion.h1
                className="hero-title"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.7 }}
              >
                {slides[current].title}
              </motion.h1>

              <motion.p
                className="hero-desc"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.7 }}
              >
                {slides[current].description}
              </motion.p>

              <motion.div
                className="hero-cta"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.7, duration: 0.6 }}
              >
                <a href="#booking" className="btn btn-primary">Reserve Your Stay</a>
                <button className="btn-video">
                  <span className="video-play-icon"><FaPlay /></span>
                  Watch Video
                </button>
              </motion.div>
            </motion.div>
          </AnimatePresence>

          <div className="hero-stats">
            {[
              { value: '500+', label: 'Luxury Rooms' },
              { value: '98%', label: 'Guest Satisfaction' },
              { value: '25+', label: 'Awards Won' },
              { value: '1995', label: 'Est. Year' },
            ].map(s => (
              <div key={s.label} className="hero-stat">
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hero-slider-nav">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`slider-dot ${i === current ? 'active' : ''}`}
            onClick={() => handleSlide(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      <div className="hero-booking-wrap" id="booking">
        <div className="container">
          <BookingForm />
        </div>
      </div>

      <a href="#featured" className="hero-scroll">
        <FaChevronDown />
      </a>
    </section>
  );
}
